import { Box, Heading, Text } from '@chakra-ui/react';

import { EnterpriseResourceImpactHighlight } from '../models/enterprise-report-content';

export function EnterpriseResourceImpactSection({
  impactTitle,
  impactHighlights,
}: {
  impactTitle: string;
  impactHighlights: EnterpriseResourceImpactHighlight[];
}) {
  return (
    <Box
      height='100%'
      paddingRight={{ base: '0px', lg: '32px' }}
      paddingY={{ base: '40px', md: '64px', lg: '120px' }}
      position='relative'
      width='100%'
    >
      <Box backgroundColor='blue.700' height='100%' left='0' position='absolute' top='0' width='100vw' zIndex='-1' />

      <Box alignItems={{ base: 'center', md: 'unset' }} display='flex' flexDirection='column' gap='32px'>
        <Heading as='h2' color='white' size='marketing-2xl'>
          {impactTitle}
        </Heading>
        <Box display='flex' flexDirection={{ base: 'column', md: 'row' }} gap={{ base: '24px', lg: '40px' }}>
          {impactHighlights.map(({ title, text }) => (
            <Box key={title} textAlign={{ base: 'center', md: 'unset' }}>
              <Text color='accent.sea-foam.500' fontSize='40px'>
                {title}
              </Text>

              <Text color='white' marginTop='8px'>
                {text}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
